import SVG from "../../SVG"
export default function Hamburger({ isCollapsed, onToggle,}) {
  return (
    <div
      className="w-20 z-50 md:hidden"
      onClick={onToggle}
    >
      <SVG
        name={isCollapsed ? "hamburger" : "hamburgerX"}
        classname={`h-5 w-auto ${isCollapsed ? "fill-white" : "fill-zi-bg1-dark dark:fill-white"}`}
      />
    </div>
  )
}